import { Component } from '@angular/core';

@Component({
  selector: 'app-chief-timeline-embed',
  templateUrl: 'embed.component.html',
  styleUrls: [],
})
export class ChiefTimelineEmbedComponent {}
